export const SKOR_TICKET_CATEGORIES = [
  {
    value: "document_issue",
    translationKey: "skorTicketDocumentIssue",
    label: "Document issue",
    subjectPlaceholder: "Which document needs to be reviewed?",
    messagePlaceholder:
      "Tell us which document is affected and what needs to be corrected.",
  },
  {
    value: "fraud",
    translationKey: "skorTicketFraud",
    label: "Suspected fraud",
    subjectPlaceholder: "What looks suspicious?",
    messagePlaceholder:
      "Describe the suspected fraud and the documents or details that concern you.",
  },
  {
    value: "score",
    translationKey: "skorTicketScore",
    label: "Score",
    subjectPlaceholder: "What is your question about the score?",
    messagePlaceholder:
      "Describe the score you see and what you would like us to review.",
  },
  {
    value: "bug",
    translationKey: "skorTicketBug",
    label: "Platform error",
    subjectPlaceholder: "What is not working correctly?",
    messagePlaceholder:
      "Describe what happened, what you expected, and the steps to reproduce the issue.",
  },
  {
    value: "account_access",
    translationKey: "skorTicketAccountAccess",
    label: "Account access",
    subjectPlaceholder: "What account access problem are you having?",
    messagePlaceholder:
      "Tell us what happens when you try to access your account. Do not include passwords or access codes.",
  },
  {
    value: "billing",
    translationKey: "skorTicketBilling",
    label: "Billing and credits",
    subjectPlaceholder: "What is your billing or credits question?",
    messagePlaceholder:
      "Describe the charge, invoice, or credit balance you would like us to review.",
  },
  {
    value: "integration_api",
    translationKey: "skorTicketIntegrationApi",
    label: "Integration / API",
    subjectPlaceholder: "Which integration or API needs help?",
    messagePlaceholder:
      "Describe the integration, the request or action, and any error message. Do not include API keys or tokens.",
  },
  {
    value: "product_question",
    translationKey: "skorTicketProductQuestion",
    label: "Product question",
    subjectPlaceholder: "What would you like to know about Skor?",
    messagePlaceholder:
      "Tell us which feature you have a question about and what you would like to do.",
  },
  {
    value: "feature_request",
    translationKey: "skorTicketFeatureRequest",
    label: "Suggestion",
    subjectPlaceholder: "What would you like us to improve or add?",
    messagePlaceholder: "Describe your suggestion and how it would help you.",
  },
  {
    value: "other",
    translationKey: "skorTicketOther",
    label: "Other",
    subjectPlaceholder: "How can we help?",
    messagePlaceholder:
      "Describe your question or issue and include any useful details.",
  },
];

export const DOCUMENT_REQUIRED_CATEGORIES = ["document_issue", "fraud"];
